import { NavigationState } from './NavigationState'
import { FULFILLED } from '../action-helper'
import { FETCH_NAVIGATION } from './actions'

const initialState: NavigationState = {
    organizations: [],
    loaded: false,
}

export const navigationReducer = (state: NavigationState = initialState, action: any): NavigationState => {
    switch (action.type) {
        case FULFILLED(FETCH_NAVIGATION): {
            const { organizations } = action.payload.data

            if (state.loaded) {
                return state
            }

            return {
                ...state,
                organizations,
                loaded: true,
            }
        }
        default:
            return state
    }
}
